import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { cutString, encodeforspace, encodeIndustryName } from '../../utils/helper';
import { isEmpty } from '../../common/utils'
import Postman from '../../utils/service';
import LinkedinIcon from 'react-share/lib/LinkedinIcon';
import { Input } from 'reactstrap';
import Cookies from 'js-cookie';

export class CompanyPeople extends Component {
    constructor(props) {
        super(props)
        this.state = {
            competitorModel: '',
            showAlertRevealPhone: false,
            empContacts: [],
            titleSearch: '',
            company_id: props.company_id,
            data: props.data,
            companyName: props.companyName,
            isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false,
        }
    }
    handleChange(e) {
        this.setState({ competitorModel: e.target.value });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({ data: this.props.data, companyName: this.props.companyName, company_id: this.props.company_id });
        }
    }


    getPhoneEmail = (id) => {
        if(!this.state.isLoggedIn) 
            return this.props.history.push('/join');
        Postman.getEmployeePhoneEmail(id)
            .then(res => {
                if (res.data.emp && res.data.emp.id) {
                    this.setState({ empContacts: { ...this.state.empContacts, [id]: res.data.emp } })
                } else {
                    this.setState({ showAlertRevealPhone: true })
                }
            })
    }

    closeAlertRevealPhone = () => {
        this.setState({ showAlertRevealPhone: false })
    }


    getQueryStrings(location) {

        var assoc = {};
        var decode = function (s) { return decodeURIComponent(s.replace(/\+/g, " ")); };
        var queryString = location.search.substring(1);
        var keyValues = queryString.split('&');

        for (var i in keyValues) {
            var key = keyValues[i].split('=');
            if (key.length > 1) {
                assoc[decode(key[0])] = decode(key[1]);
            }
        }

        return assoc;
    }
    order(name) {
        const query = this.getQueryStrings(this.props.location.location);
        let orderby = query.orderby || 'asc';
        if (name == query.order) {
            orderby = orderby == 'asc' ? 'desc' : 'asc';
        }
        return `order=${name}&orderby=${orderby}`
    }

    OrderArrow = ({ name }) => {

        const query = this.getQueryStrings(this.props.location.location);
        let orderby = query.orderby || 'asc';
        if (name == query.order) {
            orderby = orderby == 'asc' ? 'desc' : 'asc';
        }
        let dir = orderby == 'asc' ? 'up' : 'down';
        if (orderby === 'asc') {
            return (
                <i style={
                    {
                        fontFamily: "fontawesome",
                        fontStyle: "normal"
                    }
                } class="fas fa-sort-down"></i>
            );
        } else {
            return (<i
                style={
                    {
                        fontFamily: "fontawesome",
                        fontStyle: "normal"
                    }
                }
                class="fas fa-sort-up"></i>);
        }

    }

    handleChange = titleSearch => {
        this.setState(
            { titleSearch: titleSearch.target.value }, () => {
                this.getPeopleByTitle();
            }
        );

    };

    getPeopleByTitle = () => {
        Postman.getCompanyEmployeesByTitle(this.state.company_id, this.state.titleSearch)
            .then(res => {
                if (res.data.data) {
                    this.setState({ data: res.data.data })
                }
            })
    }

    render() {

        const data = this.state.data;
        const companyName = this.state.companyName;

        if (!data) {
            return null;
        }

        return (<React.Fragment>

            <div className="col-md-12 row">
                <div className="col-md-8">

                    <h2 id="competitors" >{companyName}'s People </h2>
                </div>
                {this.state.isLoggedIn && <div class="col-md-4">
                    <Input type="text"
                        name="titleSearch"
                        id="titleSearch"
                        className="form-control"
                        placeholder="Search People By Title"
                        autoFocus={true}
                        onChange={this.handleChange}
                        value={this.state.titleSearch} />
                </div>}
            </div>
            <table className="table table-bordered cstm-table">
                <thead>
                    <tr style={{ backgroundColor: 'rgb(71, 72, 102)', color: 'white' }}>
                        <th scope="col">
                            Name
                        </th>
                        <th scope="col">
                            Title
                        </th>
                        <th scope="col">
                            Email/Phone
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((emp, index) => {
                        let empId = emp.id;
                        let name = encodeforspace(emp.first_name + '-' + emp.last_name) + '-' + emp.id;
                        let empPhoneEmail = (<Link to={'/employee/' + name} style={{ borderRadius: "7px", color: '#fff' }} className='btn btn-primary'>Reveal Email/Phone</Link>)

                        let empEmail = emp.email;
                        let empPhone = emp.phone;

                        if (this.state.empContacts[empId]) {
                            empEmail = this.state.empContacts[empId].email;
                            empPhone = this.state.empContacts[empId].phone;
                        }

                        if (empEmail || empEmail) {
                            empPhoneEmail = (
                                <React.Fragment>
                                    <a href={`mailto:${empEmail}`}>{empEmail}</a>
                                    <i style={{ paddingLeft: '5px', cursor: 'pointer' }} class="fa fa-copy" onClick={() => { navigator.clipboard.writeText(empEmail) }}></i>
                                    <br />
                                    {empPhone}
                                </React.Fragment>)
                        }

                        return (<tr key={index + 'people'}>
                            <td>
                                <div style={{ display: 'inline-block' }}>
                                    {index + 1}
                                </div>
                                <div style={{ display: 'inline-block', marginLeft: 8 }}>
                                    <a href={emp.linkedIn} target="_blank" onClick={(e) => { e.stopPropagation() }} style={{ display: "inline-block", paddingRight: "5px" }}>
                                        <LinkedinIcon size={15} />
                                    </a>
                                    <Link key={emp.id} to={`/employee/` + encodeforspace(emp.first_name + '-' + emp.last_name) + '-' + emp.id} style={{ marginRight: 5, fontSize: 15, textDecoration: 'none' }}>
                                        {emp.first_name + ' ' + emp.last_name}
                                    </Link>
                                </div>
                            </td>
                            <td>{emp.title}</td>
                            <td>{empPhoneEmail}</td>
                        </tr>);
                    })}
                </tbody>
            </table>

        </React.Fragment>);
    }
}
// export const Competitors = ({ data, industry, key, companyName }) => {
//     const [competitorModel, setcompetitor] = React.useState('');



// };



// WEBPACK FOOTER //
// ./client/src/views/CompanyDetail/CompanyPeople.js